import { render } from "./home_1.vue?vue&type=template&id=8333cb1a"
import script from "./home_1.vue?vue&type=script&lang=js"
export * from "./home_1.vue?vue&type=script&lang=js"

import "./home_1.vue?vue&type=style&index=0&id=8333cb1a&lang=css"
script.render = render

export default script